import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SidebarUpdateComponent } from 'src/app/@amiga-pyme/class/sidebar-update.class';
import { StockService } from '../../../stock.service';

@Component({
  selector: 'pg-stock-price-sidebar',
  templateUrl: './stock-price-sidebar.component.html',
  providers: [MessageService]
})
export class StockPriceSidebarComponent extends SidebarUpdateComponent {
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private serviceBase: StockService
  ) {
    super('Precio', serviceBase);
  }
  salePrice = 0.0;
  purchasePrice = 0.0;
  profitMargin = 0.0;
  percent = 0.0;
  itemStock: { label: string; value: string }[];
  format = {};
  nameFormat = '';
  ngOnInit() {
    const { selectedParent, selectedChild } = this.item;
    this.format = selectedParent.format;
    this.nameFormat = selectedChild.format;
    this.item = { ...selectedParent, ...selectedChild };
    this.setItemInSideBar();
    this.salePrice = this.item?.salePrice ? this.item?.salePrice : 0;
    this.profitMargin = this.item?.profitMargin ? this.item?.profitMargin : 0;
    this.purchasePrice = this.item?.purchasePrice;
    this.fg = this.fb.group({
      salePrice: [
        this.salePrice,
        [Validators.required, Validators.min(0)]
      ],
      percentProfitMargin: [
        this.profitMargin * 100,
        [Validators.required]
      ]
    });
  }

  onSubmit() {
    const updatedData = this.fg.value;
    updatedData.profitMargin = updatedData.percentProfitMargin / 100;

    const newFormat = this.format;
    newFormat[this.nameFormat].precio = updatedData.salePrice;

    newFormat[this.nameFormat].profitMargin =
      updatedData.profitMargin.toFixed(4);
    this.updateItem$({
      format: newFormat
    });
  }

  onInputSalePrice(event) {
    const percent = this.getPercentProfitMargin(event.value);
    this.fg.get('percentProfitMargin').setValue(percent);
  }

  onInputPercentProfitMargin(event) {
    const salePrice = this.getSalePrice(event.value);
    this.fg.get('salePrice').setValue(salePrice);
  }

  getSalePrice(percent) {
    this.profitMargin = percent / 100;
    return parseFloat(
      (this.purchasePrice / (1 - this.profitMargin)).toFixed(2)
    );
  }

  getPercentProfitMargin(salePrice) {
    this.profitMargin = parseFloat(
      (1 - this.purchasePrice / salePrice).toFixed(4)
    );
    return parseFloat((this.profitMargin * 100).toFixed(2));
  }

  setItemInSideBar() {
    const fieldsStock = {
      branchStoreName: 'Sucursal',
      productName: 'Producto',
      format: 'Formato',
      subFormat: 'Sub Formato',
      expAt: 'Exp. en',
      purchasePrice: 'Precio Compra',
      profitMargin: 'Margen',
      precio: 'Precio Venta',
      stock: 'Stock'
    };

    const keysStock = Object.keys(fieldsStock);
    this.itemStock = keysStock.map((key) => {
      return {
        label: fieldsStock[key],
        value: this.item[key]
      };
    });
  }
}
